export function formatConsumption(value: number | undefined) {
	if (value === undefined) return undefined;
	return value.toFixed(3);
}

export function formatAlerts(count: number | undefined, noAlertsLabel: string) {
	if (count === undefined) return undefined;
	return count === 0 ? noAlertsLabel : count;
}
